'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "onRemove", "zIndex"];
import { Component } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { EARTH_LAYER } from 'foundations-components/transitional/constants';
import withTinyMcePopoverLifecycle from '../hoc/withTinyMcePopoverLifecycle';
import { jsx as _jsx } from "react/jsx-runtime";
class TinyMcePopover extends Component {
  constructor(props) {
    super(props);
    if (props.editor.settings.inline && !!props.editor.settings.canvasToolbar) {
      this.zIndex = Number(EARTH_LAYER);
    }
  }
  render() {
    const _this$props = this.props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(Popover, Object.assign({}, rest));
  }
}
TinyMcePopover.defaultProps = {
  animateOnMount: false,
  autoPlacement: true,
  closeOnOutsideClick: true,
  closeOnTargetLeave: false,
  defaultOpen: false,
  openOnTargetEnter: false,
  pinToConstraint: ['top', 'bottom'],
  pinToOutOfBoundsTarget: false,
  use: 'default',
  arrowSize: 'small',
  placement: 'right bottom',
  animateOnToggle: false,
  open: true
};
export default withTinyMcePopoverLifecycle(TinyMcePopover);